import React, { useEffect, useState } from 'react';
import FAQ from '../Components/FAQsAsk';
import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import AnimatedFAQs from '../Components/AnimatedFAQ';
import Sep from "../Assets/sep.svg";
import { supabase } from "../supabaseClient";

const FAQZ = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const res = await supabase.from("faq_categories").select("*");
      const res2 = await supabase.from("faq_items").select("*");
      const cats = res.data.map((c) => ({
        id: c.id,
        title: c.category_name,
        items: res2.data
          .filter((it) => it.category_id === c.id)
          .sort((a, b) => a.sort_order - b.sort_order)
          .map((it) => ({ question: it.question, answer: it.answer })),
      }));
      setCategories(cats);
    };
    getData();
  }, []);

  return (
    <>
      <NavBar active="faqs" />
      <AnimatedFAQs />
      {categories.map((cat, idx) => (
        <React.Fragment key={cat.id}>
          <FAQ title={cat.title} faqItems={cat.items} />
          {idx < categories.length - 1 && (
            <img src={Sep} className="widdy" alt="separator" />
          )}
        </React.Fragment>
      ))}
      <Footer />
    </>
  );
};

export default FAQZ;